import apiClient from './apiClient';

export const notificationApi = {
  // Alle Benachrichtigungen
  getAll: async (unreadOnly = false) => {
    const response = await apiClient.get('/notifications', {
      params: { unreadOnly }
    });
    return response.data;
  },

  // Unread Count
  getUnreadCount: async () => {
    const response = await apiClient.get('/notifications/unread-count');
    return response.data.count;
  },

  // VAPID Public Key
  getVapidPublicKey: async () => {
    const response = await apiClient.get('/notifications/vapid-public-key');
    return response.data.publicKey;
  },

  // Als gelesen markieren
  markAsRead: async (id) => {
    const response = await apiClient.put(`/notifications/${id}/read`);
    return response.data;
  },

  // Alle als gelesen
  markAllAsRead: async () => {
    const response = await apiClient.put('/notifications/read-all');
    return response.data;
  },

  // Alle Notifications zu einer Anfrage als gelesen markieren.
  // Wird beim Öffnen der Anfrage-Detail-Seite getriggert, damit die Glocke
  // sich automatisch leert sobald der Disponent die Anfrage sieht.
  markReadByAnfrage: async (anfrageId) => {
    if (!anfrageId) return { count: 0 };
    const response = await apiClient.put(`/notifications/read-by-anfrage/${anfrageId}`);
    return response.data;
  },

  // Löschen
  delete: async (id) => {
    const response = await apiClient.delete(`/notifications/${id}`);
    return response.data;
  },

  // Alle löschen
  deleteAll: async () => {
    const response = await apiClient.delete('/notifications/delete-all');
    return response.data;
  },

  // Push Subscribe
  subscribePush: async (subscription, deviceInfo) => {
    const response = await apiClient.post('/notifications/subscribe', {
      endpoint: subscription.endpoint,
      keys: {
        p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh')))),
        auth: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth'))))
      },
      ...deviceInfo
    });
    return response.data;
  },

  // Push Unsubscribe
  unsubscribePush: async (endpoint) => {
    const response = await apiClient.delete('/notifications/subscribe', {
      data: { endpoint }
    });
    return response.data;
  }
};

export default notificationApi;
